<template>
  <div v-if="demandeIntervention">
    <div class="entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" v-if="demandeIntervention.id">
                  {{ $t('editionIntervention.title.edit', { code: demandeIntervention.code }) }}
                </h1>
                <h1 class="title is-size-3" v-else>
                  {{ $t('editionIntervention.title.add') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <a class="button btn-modal-annuler" @click="$router.go(-1)">
              {{ $t('general.button.cancel') }}
            </a>
            <a class="button is-addOrEdit mgl-10px"
               @click="checkPermissions(permIntervention.maj) ? addOrUpdateIntervention()
                  : showPopUp()">
              {{ $t('general.button.sauvegarder') }}
            </a>
            <piece-jointe-button
              class="mgl-10px"
              :perm="permIntervention.maj">
            </piece-jointe-button>
          </div>
        </div>
      </div>
    </div>
    <div class="mgt-20px">
      <error-msg-component :messages="messages"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           :error="error"
                           :title="'addEditCivilite.error.problemOccurred'"
                           :withEmplyFields="true"
                           @close="error = $event"/>
    </div>
    <onglet-manager
      v-if="demandeIntervention"
      class="mgt-20px"
      :onglets="onglets">
      <template #informations>
        <informations :demandeIntervention="demandeIntervention" />
      </template>
      <template #faces>
        <tab-select-faces-demande-logistique
          :liste-faces-base="listeFacesBase"
          :displayColumnLogistique="true"
          :isMairie="isMairie"
          @selectFaces="handleFacesSelection"
        />
      </template>
    </onglet-manager>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import breadcrumb from '@/components/general/breadcrumb';
import { INTERVENTION } from '@/configuration/logistique/permissionsLogistiqueConf';
import genererDemandeIntervention from '@/services/logistique/intervention/genererDemandeIntervention';
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import { create, get, update } from '@/api/logistique/demandeLogistique/index';
import messageSucces from '@/services/general/messageSucces';
import formatIsoDate from '@/services/general/formatIsoDate';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/logistique/intervention/translateIntervention';
import { fillInfoOtPatrimoine, getInfoPat } from '@/services/logistique/ordreTravail/tech/fillInfoOtPatrimoine';
import { PRODUIT } from '@/configuration/ville/villeConf';
import validation from '@/services/logistique/intervention/validationIntervention';
import validationDemandeEtFaces from '@/services/logistique/demandeLogistique/validation';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import { CATEGORIE_REGROUPEMENT, CATEGORIE_REGROUPEMENT_LC, CATEGORIE_REGROUPEMENT_MAIRIE } from '@/configuration/catalogue/produitConf';
import { getLignesSelectionFaceForDemandeAffichage } from '@/services/dcf/reseauTempo/getListeFacesForSelection';
import Informations from '@/components/logistique/demande/edition/demandeInformations';
import ongletManager from '@/components/general/ongletManager';
import tabSelectFacesDemandeLogistique
  from '@/components/devisCommandeFacture/facesSelectInReseauTempo/tabSelectFacesDemandeLogistique';
import { GUID_VIDE } from '@/configuration/general';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';

const Attachments = createNamespacedHelpers('attachments');
const Societe = createNamespacedHelpers('societe');
const Permissions = createNamespacedHelpers('permissions');
const Intervention = createNamespacedHelpers('intervention');
const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'm_intervention',
  data() {
    return {
      permIntervention: INTERVENTION,
      demandeIntervention: null,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      PRODUIT,
      isUpdate: false,
      listeFacesBase: [],
    };
  },
  components: {
    breadcrumb,
    errorMsgComponent,
    pieceJointeButton,
    Informations,
    tabSelectFacesDemandeLogistique,
    ongletManager,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
    }),
    ...Intervention.mapGetters({
      interventionCourant: 'interventionCourant',
    }),
    ...User.mapGetters({
      utilisateur: 'user',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    nbrFacesSelected() {
      const number = this.listeFacesBase.filter(f => f.selected).length;
      if (number > 0) return `(${number})`;
      return '';
    },
    breadcrumb() {
      return [
        { title: this.$t('editionIntervention.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('editionIntervention.breadcrumb.listeDemandeIntervention'), route: { name: 'l.logistique.demande_intervention' }, isActive: false },
        { title: this.$route.params.id ? this.$t('editionIntervention.breadcrumb.edit') : this.$t('editionIntervention.breadcrumb.nouvelleIntervention'), route: {}, isActive: true },
      ];
    },
    onglets() {
      const tabs = [
        {
          key: 'informations',
          title: this.$t('demandeLogistique.creationOrUpdate.tab.informations'),
        },
      ];
      if (this.isProduitRegroupement) {
        tabs.push({
          key: 'faces',
          title: this.$t('demandeLogistique.creationOrUpdate.tab.faces', { nbrFacesSelected: this.nbrFacesSelected }),
        });
      }
      return tabs;
    },
    isProduitRegroupement() {
      const regroupements = [
        CATEGORIE_REGROUPEMENT,
        CATEGORIE_REGROUPEMENT_MAIRIE,
        CATEGORIE_REGROUPEMENT_LC,
      ];
      return regroupements
        .some(r => r === this.demandeIntervention.typeProduit);
    },
    isMairie() {
      return this.demandeIntervention.typeProduit === CATEGORIE_REGROUPEMENT_MAIRIE;
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      insertAttachments: 'insert',
      updateAttachments: 'update',
    }),
    ...Intervention.mapActions({
      setInterventionCourant: 'setInterventionCourant',
    }),
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    handleFacesSelection(faces) {
      this.demandeIntervention.demandeLogistiqueSelProduit = cloneDeep(faces)
        .map(face => {
          const dmdLogistiqueSelProduit = (this.demandeIntervention?.demandeLogistiqueSelProduit
            ?? []).find(d => d.produitId === face.produitId);
          return {
            produitId: face.produitId,
            estDisponible: face.dispo,
            ...(dmdLogistiqueSelProduit && { id: dmdLogistiqueSelProduit?.id ?? GUID_VIDE }),
          };
        });
    },
    async addOrUpdateIntervention() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        let demandeIntervention = cloneDeep(this.demandeIntervention);
        demandeIntervention.datePlanification = formatIsoDate(
          demandeIntervention.datePlanification,
        );
        demandeIntervention.dateLimite = formatIsoDate(
          demandeIntervention.dateLimite,
        );
        if (this.$route.params.id) {
          demandeIntervention = (await update(demandeIntervention)).data.result;
          await this.updateAttachments(demandeIntervention.id);
          messageSucces(this.$t('editionIntervention.success.demandeUpdate'));
        } else {
          demandeIntervention.societeId = this.societeActiveId;
          demandeIntervention = (await create(demandeIntervention)).data.result;
          await this.insertAttachments(demandeIntervention.id);
          messageSucces(this.$t('editionIntervention.success.demandeAdd'));
        }
        loadingComponent.close();
        await this.$router.push(
          { name: 'c.logistique.demande_intervention', params: { id: demandeIntervention.id } },
        );
      } catch (e) {
        if (e.response.data.error) {
          this.champsVide = [];
          this.messagesChampsVide = [];
          this.messages = [];
          validation(e.response, this.messages, null);
          validationDemandeEtFaces(e.response, this.messages);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
          loadingComponent.close();
          return;
        }
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    genererDemandeIntAndFillAgence() {
      const demandeIntervention = genererDemandeIntervention();
      demandeIntervention.infoPatrimoine = {
        faceId: null,
        materielId: null,
        dispositifId: null,
        emplacementId: null,
      };
      if (this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === this.utilisateur.agenceId;
      })) {
        demandeIntervention.agenceId = this.utilisateur.agenceId;
      } else demandeIntervention.agenceId = this.agencesSelectionnees[0].agenceId;
      return demandeIntervention;
    },
    async initSelFaces() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadParametreUtilisateur();
        const users = this.parametre(PARAMETRES_KEYS.utilisateur);
        const liste = await getLignesSelectionFaceForDemandeAffichage(
          this.demandeIntervention, users, this.societeActiveId,
          this.demandeIntervention.datePlanification);
        liste.sort((a, b) => a.affecteLogistiquement - b.affecteLogistiquement);
        this.listeFacesBase = cloneDeep(liste)
          .map(face => {
            const dmdLogistiqueSelProduit = this
              .demandeIntervention?.demandeLogistiqueSelProduit
              .find(f => f.produitId === face.produitId);
            if (dmdLogistiqueSelProduit) {
              face.selected = true;
            }
            return face;
          });
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'DemandeLogistique' });
      if (this.interventionCourant) {
        this.demandeIntervention = this.interventionCourant;
        const infoPatrimoine = await getInfoPat(this.demandeIntervention.infoPatrimoine);
        this.demandeIntervention.adresse = infoPatrimoine.emplacement.adresseCadastrale;
        this.setInterventionCourant(null);
      } else if (this.$route.params.id) {
        await this.setAttachmentElementId({ id: this.$route.params.id });
        const demandeIntervention = (await get(this.$route.params.id)).data.result;
        if (demandeIntervention.datePlanification) {
          demandeIntervention.datePlanification = new Date(demandeIntervention.datePlanification);
        }
        if (demandeIntervention.dateLimite) {
          demandeIntervention.dateLimite = new Date(demandeIntervention.dateLimite);
        }
        demandeIntervention.infoPatrimoine = {
          faceId: demandeIntervention.faceId,
          materielId: demandeIntervention.materielId,
          dispositifId: demandeIntervention.dispositifId,
          emplacementId: demandeIntervention.emplacementId,
        };
        const infoPatrimoine = await getInfoPat(demandeIntervention.infoPatrimoine);
        await fillInfoOtPatrimoine(demandeIntervention.infoPatrimoine, true);
        this.demandeIntervention = demandeIntervention;
        if (infoPatrimoine.emplacement) {
          this.demandeIntervention.adresse = infoPatrimoine.emplacement.adresseCadastrale;
        }
        if (this.isProduitRegroupement) {
          await this.initSelFaces();
        }
        this.isUpdate = true;
        this.setInformationPage(this.$t('pageGeneral.modification', { item: this.demandeIntervention.code }));
      } else {
        this.demandeIntervention = this.genererDemandeIntAndFillAgence();
        this.setInformationPage(this.$t('pageLogistique.intervention.creation'));
      }
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>-
